import { dbProperties } from "./PropertiesLight"

export class PropertiesDBLight { // uses lightweight version of properties database

    MAX_RECURSION = 10; // safety counter in case of endless loop of dependent units
    HUGE_VAL = 1e308;
    property = dbProperties[0];
    fromUnit = dbProperties[0].units[0];
    toUnit = dbProperties[0].units[0];
    fromFactor = 1;
    fromOffset = 0;
    toFactor = 1;
    toOffset = 0;

    constructor() {
    }

    SetProperty(name: string) {
        this.property = this.FindProperty(name);
        // set default units and factors
        this.fromUnit = this.property.units[0];
        this.toUnit = this.property.units[0];
        this.fromFactor = 1;
        this.fromOffset = 0;
        this.toFactor = 1;
        this.toOffset = 0;
    }

    SetFromUnit(name: string) {
        this.fromUnit = this.FindUnit(name);
        this.fromFactor = this.GetFactor(this.fromUnit, 0);
        this.fromOffset = this.fromUnit["offset"] || 0;
    }

    GetFactor(unit, depth = 0) {
        if (depth > this.MAX_RECURSION) throw "endless loop of dependent units";
        if (unit.multiple != undefined) {
            if (unit.of != undefined) {
                var multipleUnit = this.FindUnit(unit.of);
                var multipleFactor = this.GetFactor(multipleUnit, ++depth);
                return unit.multiple * multipleFactor;
            }
            else if (unit.per != undefined) {
                var multipleUnit = this.FindUnit(unit.per);
                var multipleFactor = this.GetFactor(multipleUnit, ++depth);
                return multipleFactor / unit.multiple;
            }
        }
        return unit.factor || 1;
    }

    SetToUnit(name: string) {
        this.toUnit = this.FindUnit(name);
        this.toFactor = this.toUnit.factor || 1;
        this.toOffset = this.toUnit["offset"] || 0;
    }

    GetConstant(name: string) {
        return this.FindConstant(name).value;
    }

    FindProperty(name: string) {
        for (var i = 0; i < dbProperties.length; i++) {
            if (typeof (dbProperties[i].name[0]) === "string") {
                if (dbProperties[i].name[0] === name) return dbProperties[i];
            }
            else {
                for (var j = 0; j < dbProperties[i].name.length; j++) {
                    if (dbProperties[i].name[j] === name) return dbProperties[i];
                }
            }
        }
        throw "Property named '" + name + "' was not found";
    }

    GetPropertySIUnit(property:any):any {
        return property.units[0];
    }

    FindPropertyUnit(property:any, name: string) {
        for (var i = 0; i < property.units.length; i++) {
            if (typeof (property.units[i].name) === "string") {
                if (property.units[i].name === name) return property.units[i];
            }
            else {
                for (var j = 0; j < property.units[i].name.length; j++) {
                    if (property.units[i].name[j] === name) return property.units[i];
                }
            }
        }
        throw "Unit named '" + name + "' was not found";
    }

    FindUnit(name: string):any {
        this.FindPropertyUnit(this.property, name);
    }

    FindPropertyConstant(property:any, name: string) {
        for (var i = 0; i < property.constants.length; i++) {
            if (typeof (property.constants[i].name) === "string") {
                if (property.constants[i].name === name) return property.constants[i];
            }
            else {
                for (var j = 0; j < property.constants[i].name.length; j++) {
                    if (property.constants[i].name[j] === name) return property.constants[i];
                }
            }
        }
        throw "Constant named '" + name + "' was not found";
    }

    FindConstant(name: string):any {
        this.FindPropertyConstant(this.property, name);
    }

    ConvertUnits(value:number, fromUnit:any, toUnit:any):number {
        return this.Convert(value, fromUnit.factor||1.0, fromUnit.offset||0.0, toUnit.factor||1.0, toUnit.offset||0.0);
    }

    Convert(value: number, fromFactor: number, fromOffset: number, toFactor: number, toOffset: number):number {
        var fromInverse = false, toInverse = false;
        if (fromFactor < 0) {
            fromInverse = true;
            fromFactor = Math.abs(fromFactor);
        }
        if (toFactor < 0) {
            toInverse = true;
            toFactor = Math.abs(toFactor);
        }

        if (fromInverse) {  // use inverse proportionality
            if (value != 0) value = 1.0 / value;
            else value = this.HUGE_VAL;
        }

        value = fromFactor / toFactor * (value - fromOffset) + toOffset;

        if (toInverse) {  // use inverse proportionality
            if (value != 0) value = 1.0 / value;
            else value = this.HUGE_VAL;
        }

        return value;
    }
}


//public double Convert(double val, Unit fromUnit, Unit toUnit)
//{
//  if(fromUnit == null) throw new Exception("Unit '" + fromUnit + "' not found.");
//if(  toUnit == null) throw new Exception("Unit '" +   toUnit + "' not found.");
//// check to see if the two units are defined in terms of each other
////if (fromUnit.RelUnit == null && toUnit.RelUnit == null)
////  return val * fromUnit.Factor / toUnit.Factor;
//if(fromUnit.RelUnit ==   toUnit.Name) 
//    return val*fromUnit.Factor;
//if(  toUnit.RelUnit == fromUnit.Name) 
//    return val/  toUnit.Factor;
//// follow units chain from FromUnit back to SI
//double factor = 1.0;
//for (int i = 0; i < MAX_STEPS; i++)
//{
//  factor *= fromUnit.Factor;
//  if (fromUnit.RelUnit == null || fromUnit.RelUnit == toUnit.Name) break;
//  fromUnit = GetUnit(fromUnit.RelUnit);
//}
//    // follow units chain from ToUnit back to SI
//for (int i = 0; i < MAX_STEPS; i++)
//{
//  factor /= toUnit.Factor;
//  if (toUnit.RelUnit == null || toUnit.RelUnit == fromUnit.Name) break;
//  toUnit = GetUnit(toUnit.RelUnit);
//}
//return val*factor;
//}
